import { useContent } from "@/content/ContentContext";
import { Eyebrow, Reveal } from "./Reveal";

const CHAPTERS = [
    {
        num: "01",
        title: "The Rejection",
        copy: "The most advertised warranty brands in America got rich on TV spots and robocalls — then wrote contracts the service counter stopped honoring. Denied claims, sub-rate payouts, hours on hold. Advisors learned to say it flat: we don't take that here.",
    },
    {
        num: "02",
        title: "Built From the Service Lane",
        copy: "AdvantaShield wasn't dreamed up in a call center. It was engineered by dealership service directors who process claims every single day — people who know exactly why contracts get refused, and set out to build one that never would.",
    },
    {
        num: "03",
        title: "Accepted Where It Matters",
        copy: "Our coverage is welcomed at franchise dealership service departments — and it's sold right there on the showroom floor. When your car needs work, you hand over the card and the claim starts. No begging. No hold music.",
    },
    {
        num: "04",
        title: "Coverage as a Subscription",
        copy: "No $3,000 price tag stapled to your contract. Pay monthly, quarterly, or annually — and cancel anytime. Protection that works like the rest of your life: a subscription, not a second car payment.",
    },
];

export const Manifesto = () => {
    const content = useContent();

    return (
    <section
        id="manifesto"
        data-testid="manifesto-section"
        className="relative py-24 md:py-36"
    >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <Eyebrow>{content.manifesto_eyebrow}</Eyebrow>
                <h2 className="mt-5 max-w-3xl font-display text-3xl font-bold leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-5xl">
                    {content.manifesto_heading_a}{" "}
                    <span className="text-sky-400">{content.manifesto_heading_b}</span>
                </h2>
            </Reveal>

            <div className="mt-16 md:mt-20">
                {CHAPTERS.map((c, i) => (
                    <Reveal key={c.num} delay={i * 0.06}>
                        <div
                            data-testid={`manifesto-chapter-${c.num}`}
                            className="group grid grid-cols-1 gap-4 border-t border-white/10 py-10 transition-colors duration-500 hover:border-sky-400/30 md:grid-cols-12 md:gap-8 md:py-14"
                        >
                            <p className="font-mono text-sm font-medium text-sky-400 transition-transform duration-500 group-hover:translate-x-2 md:col-span-2 md:text-base">
                                / {c.num}
                            </p>
                            <h3 className="font-display text-2xl font-semibold tracking-tight text-white md:col-span-4 md:text-3xl">
                                {c.title}
                            </h3>
                            <p className="max-w-xl text-base leading-relaxed text-slate-400 md:col-span-6">
                                {c.copy}
                            </p>
                        </div>
                    </Reveal>
                ))}
                <div className="border-t border-white/10" />
            </div>
        </div>
    </section>
    );
};
